import {Component, inject, OnInit} from '@angular/core';
import {CustomersService} from "../../services/customers/customers.service";
import {NzTableModule} from 'ng-zorro-antd/table';
import {CommonModule} from '@angular/common';
import { FormsModule } from '@angular/forms';

import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzTagModule } from 'ng-zorro-antd/tag';
import {Router} from "@angular/router";
import { Buffer } from 'buffer';

@Component({
  selector: 'users',
  standalone: true,
  imports: [CommonModule, NzTableModule, FormsModule, NzButtonModule, NzIconModule, NzInputModule, NzTagModule],
  templateUrl: './users.component.html',
  styleUrl: './users.component.scss'
})
export class UsersComponent implements OnInit {
  customersService = inject(CustomersService);
  router = inject(Router);
  users: any = [];
  searchQuery: string = ''
  loading: boolean = false;

  ngOnInit() {
  }
  onSearch(): void {
    const query = this.searchQuery.trim();
    if (query) {
      this.loadUsers(query);
    }
  }

  loadUsers(query: string): void {
    this.loading = true;
    this.customersService.getUsersSearchResult(query).subscribe({
      next: res => {
        this.users = res;
        console.log('Search result:', res);
        this.loading = false
      },
      error: err => {
        console.error('Error fetching users:', err);
        this.loading = false
      }
    });
  }
  openTenant(id: string){
    let encodedId = Buffer.from(id).toString('base64')
    this.router.navigateByUrl(`tenants/${encodedId}`)
  }
}
